<template>
  <div :class="`form-element form-${type}-element`">
    <FormLabel
      :required="options.required"
      :title="options.title"
      :filled="internalValue !== undefined && internalValue !== null"
      :field-type="type"
    />
    <v-row>
      <v-col class="pr-4 pt-0">
        <v-slider
          v-if="!options.type"
          v-model="internalValue"
          class="align-center"
          ticks="always"
          :max="options.max"
          :min="options.min || 1"
          :step="options.step || 1"
          hide-details
        >
          <template v-slot:append>
            <v-text-field
              v-model="internalValue"
              class="mt-0 pt-0"
              hide-details
              single-line
              type="number"
              :step="options.step || 1"
              style="width: 60px"
            />
          </template>
        </v-slider>
        <div
          v-else
          class="d-flex"
        >
          <div class="flex-grow-1">
            <v-rating
              v-model="stepValue"
              :full-icon="icon.full"
              :empty-icon="icon.empty"
              :color="icon.color"
              :length="options.max / (options.step || 1)"
            >
              <template v-if="icons[options.type]" v-slot:item="props">
                <v-icon
                  v-text="icons[options.type][Math.round((props.index / (options.max / (options.step || 1))) * icons[options.type].length)] + (props.isFilled ? '' : '-outline')"
                ></v-icon>
              </template>
            </v-rating>
          </div>
          <div class="flex-shrink-1">
            <v-text-field
              v-model="internalValue"
              class="mt-0 pt-0"
              hide-details
              single-line
              type="number"
              :step="options.step || 1"
              style="width: 60px"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FormLabel from '../FormLabel';

export default {
  components: {
    FormLabel
  },
  props: {
    value: { type: [String, Number], default: null },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data: () => ({
    icons: {
      smile: ['mdi-emoticon-sad', 'mdi-emoticon-neutral', 'mdi-emoticon-happy']
    }
  }),
  computed: {
    icon () {
      if (this.options.type === 'hearts') {
        return {
          color: '#DD2C00',
          empty: 'mdi-heart-outline',
          full: 'mdi-heart'
        };
      } else if (this.options.type === 'smile') {
        return {
          color: '#FFEA00',
          empty: 'mdi-emoticon-happy-outline',
          full: 'mdi-emoticon-happy'
        };
      }

      return {
        color: '#FFEA00',
        empty: 'mdi-star-outline',
        full: 'mdi-star'
      };
    },
    internalValue: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    },
    stepValue: {
      get () {
        return this.value / (this.options.step || 1);
      },
      set (v) {
        this.$emit('input', v * (this.options.step || 1));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-rating {
  white-space: pre-wrap;
}
</style>
